import api from './api';

const adminApi = {
  get: (url, config = {}) => api.get(url, withToken(config)),
  post: (url, data, config = {}) => api.post(url, data, withToken(config)),
  patch: (url, data, config = {}) => api.patch(url, data, withToken(config)),
  delete: (url, config = {}) => api.delete(url, withToken(config)),
};

function withToken(config) {
  const token = sessionStorage.getItem('adminToken');
  return { ...config, headers: { ...(config.headers || {}), 'X-Admin-Token': token } };
}

export default adminApi;
